export default "__VITE_ASSET__CR7BQwra__"